import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 90px;
  padding: 3em;

  @media (max-width: 768px) {
    gap: 20px;
    padding: 0em;
  }
`;
